import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { type VariantProps, tv } from "tailwind-variants";
import { cn } from "../../../../util/classNameConstructor";
import Button from "../../../core/button/Button";
import Icon from "../../../core/icon/Icon";

const HandleStyles = tv({
  slots: {
    Handle:
      "text-icon-subdued hover:text-icon-default m-1 cursor-grab opacity-0 group-hover/cell:opacity-100",
    Delete:
      "leading-0 text-icon-default z-50 m-1 flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center",
  },
});
interface HandleItemProps
  extends VariantProps<typeof HandleStyles>,
    React.HTMLAttributes<HTMLDivElement> {
  active: boolean;
  deletable: boolean;
  handleDelete: () => void;
  mode?: "edit" | "display";
  type?: "option" | "column" | "row";
}

export const HandleItem = ({
  active,
  deletable,
  handleDelete,
  mode,
  type = "option",
  draggable = true,
  ...props
}: HandleItemProps) => {
  const { t } = useTranslation();
  const [hover, setHover] = useState(false);
  useEffect(() => {
    if (!active) setHover(false);
  }, [active]);
  const { Handle, Delete } = HandleStyles();
  const row = type !== "column";
  return active && deletable ? (
    <Button
      onMouseDown={handleDelete}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      // {...props}
      classNameWrapper={Delete({
        className: cn(
          "w-5 text-text-subdued",
          row ? "relative -start-2" : "",
          props.className,
        ),
      })}
      className="!bg-transparent !text-current"
      variant="shapeless"
      tooltipLabel={t("util:delete", {
        val: t(`global:${type}`),
      })}
      leadingIcon={hover ? "x-circle" : "x-sm"}
    />
  ) : mode === "edit" ? (
    <div
      // {...props}
      className={Handle({
        className: cn(
          row ? "relative -start-2" : "",
          !draggable ? "pointer-events-none !opacity-0" : "",
          props.className,
        ),
      })}
    >
      <Icon name={row ? "handle-vertical" : "handle-horizontal"} />
    </div>
  ) : null;
};
